import {
  ResourceAdapterInteface,
  ListResourcesInput,
} from 'src/adapter/ResourceAdapterInterface';
import {
  ResourceModelUpdateAttributes,
  ResourceModelCreateAttributes,
  ResourceGetAttributes,
} from 'src/models/ResourceModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosResourceAdapter implements ResourceAdapterInteface {
  async listResources(
    conditions?: ListResourcesInput
  ): Promise<{ total: number; data: ResourceGetAttributes[] }> {
    try {
      const res = await api.get('/resources', {
        params: conditions,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getResource(id: string): Promise<ResourceGetAttributes> {
    try {
      const res = await api.get(`/resources/${id}`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async createResource(
    attributes: ResourceModelCreateAttributes
  ): Promise<ResourceGetAttributes> {
    try {
      const res = await api.post('/resources', attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async updateResource(
    id: string,
    attributes: ResourceModelUpdateAttributes
  ): Promise<ResourceGetAttributes> {
    try {
      const res = await api.put(`/resources/${id}`, attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async deleteResource(id: string): Promise<boolean> {
    try {
      return await api.delete(`/resources/${id}`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async bulkDeleteResources(ids: string[]): Promise<boolean> {
    return true;
  }
  async csvUpload(file: File): Promise<boolean> {
    return true;
  }
}
